<template>
  <div class="A1">
    <!-- 头部 -->
    <Header></Header>
    <!-- 内页大图 -->
    <Banner></Banner>
    <!-- 二级导航 -->
    <NavSecond></NavSecond>
    <!-- 面包屑 -->
    <Breadcrumb></Breadcrumb>
    <!-- 内容 -->
    <div class="container">
      <div class="wrap">
        <div class="ql-editor" v-html="content"></div>
      </div>
      <!--<div class="wrap">-->
        <!--<img src="@/assets/images/Serve04@2x.png" alt="">-->
        <!--<p>中国举重博物馆全面免费对外开放（特殊临展除外）。周一闭馆，遇法定节假日正常开放，闭馆顺延至节后第一天。周二至周日-->
          <!--09:00-17:00，16:30观众停止入场，17:00闭馆。<span>参观请通过举博官网进行预约。</span></p>-->
        <!--<img src="@/assets/images/Serve05@2x.png" alt="">-->
        <!--<p>1.入馆车辆的停放按照物价部门核定并公示的收费标准进行收费。</p>-->
        <!--<p>2.入馆请自觉接受安全检查，请勿将易燃易爆物品、扩音设备、食品、饮料等各类禁限带物品及宠物带入场馆。</p>-->
        <!--<p>3.行动不便、身体有潜在疾病的观众需有人陪同方可入馆参观。</p>-->
        <!--<p>4.醉酒者、衣履不整者以及无行为能力或限制行为能力者，无监护人陪伴的谢绝入馆。</p>-->
        <!--<p>5.展馆内部分场所地面光滑，部分展厅亮度较低，请注意安全；请勿有妨碍其他观众参观的行为。</p>-->
        <!--<p>6.未经官方审核同意，请勿摄像、直播，请勿在展馆内使用闪光灯及自拍杆、三脚架、云台等支架类摄影器材。</p>-->
        <!--<p>7.严禁翻越围挡护栏、触摸展品，请自觉爱护展览、服务设施，如造成损坏，须照价赔偿并承担相应的法律责任。</p>-->
        <!--<p>8.请自觉遵守公共秩序，爱护公共设施，展馆内禁止吸烟，请勿喧哗、追跑打闹、攀爬躺卧。</p>-->
        <!--<p>9.请保持公共卫生，在展馆内勿随意投掷、丢弃杂物。</p>-->
        <!--<p>10.如遇我院重大或临时性活动，须遵从我院安排；如遇各类突发事件，请服从工作人员指挥。</p>-->
      <!--</div>-->
      <!--<div class="wrap-last">-->
        <!--<img src="@/assets/images/Serve06@2x.png" alt="">-->
      <!--</div>-->
    </div>
    <!-- 底部 -->
    <Footer></Footer>
  </div>
</template>

<script>
  import {getSingle} from "@/api";
  import {mixin} from '@/mixin/index.js';
  import Header from "@/common/Header";
  import Footer from "@/common/Footer";
  import Banner from "@/common/Banner";
  import NavSecond from "@/common/NavSecond";
  import Breadcrumb from "@/common/Breadcrumb";

  export default {
    name: "A1",
    mixins : [mixin],
    components: {
      Header,
      Footer,
      Banner,
      NavSecond,
      Breadcrumb
    },
    data(){
      return{
        // 富文本内容
        content: ``,
      }
    },
    watch:{
      '$store.getters.lang' : function(val) {
        this.getData()
      }
    },
    created() {
      this.getData()
    },
    methods:{
      async getData(val) {
        let params = {
          pageNum: 1,
          pageSize: 10,
          orderByColumn: "create_time",
          articleClass: this.$store.getters.lang,
          articleType: "参观指引",
          articleKey:'cms'
        }
        val ? params = Object.assign({},params,val) : ''
        let {data:{rows}} = await getSingle(params)

        rows[0].articleContent = this.updateImageUrl(rows[0].articleContent)
        this.content = rows[0].articleContent
      },
    }
  }
</script>

<style scoped lang="less">
  body {
    background: #f6f6f6;
  }
  .container{
    padding-bottom: 100px;
    .wrap {
      /*width: 1210px;*/
      width: 1384px;
      margin: 0 auto;
      overflow: hidden;

      img:nth-of-type(1) {
        display: block;
        margin: 0 auto 48px;
      }

      img:nth-of-type(2) {
        display: block;
        margin: 104px auto 68px;
      }

      img:nth-of-type(3) {
        display: block;
        margin: 120px auto 0px;
      }

      p {
        font-family: Source Han Sans CN;
        font-size: 24px;
        color: #666666;
        line-height: 48px;

        span {
          color: #222;
        }
      }
    }
    .wrap-last {
      width: 1384px;
      margin: 0 auto;
      overflow: hidden;

      img {
        display: block;
        margin: 128px auto 92px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Serve/A1/A1.vue